import React from 'react';
import Soccer from '@material-ui/icons/SportsSoccer';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Group from '@material-ui/icons/Group';
import AccountCircle from '@material-ui/icons/AccountCircle';


export const SidebarData = [
  {
    title: 'Matches',
    path: '/dashboard',
    icon: <Soccer/>,
    cName: 'nav-text'
  },
  {
    title: `Favorites`,
    path: '/favorites',
    icon: <FavoriteBorder/>,
    cName: 'nav-text'
  },
  {
    title: 'Bets',
    path: '/bets',
    icon: <MonetizationOn/>,
    cName: 'nav-text'
  },
  {
    title: 'Highscore',
    path: '/highscore',
    icon: <Group/>,
    cName: 'nav-text'
  },
  {
    title: 'Profile',
    path: '/profile',
    icon: <AccountCircle/>,
    cName: 'nav-text'
  }
];